import ff from './ff';

export default class c42d {

static d_defs = {

/*
  DROP TABLE t_c42r;
  CREATE TABLE "t_c42r" (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER,
    c42rb21f INTEGER,
    c42rb11k INTEGER,
    c42rcx1i INTEGER,
    c42rcy1t TEXT,
    c42rcy1f INTEGER,
    c42rcz1i INTEGER
    , CONSTRAINT c42r_unq1 UNIQUE (c42rb21f, c42rb11k, _vsn)
  );
  INSERT INTO t_c42r (_vsn, _ltt, c42rb21f, c42rb11k, c42rcx1i, c42rcy1t, c42rcy1f, c42rcz1i) 
  VALUES (1, 1, 1, 3, 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_c42r SET _fst = _key;
*/

  c42r: {
    0: {
      pfx: '担当情報',
      b_vsn: true,
      d_insFlds: {
        c42rb21f: -1,
        c42rb11f: -1,
      },
      dd_fldDefss: {
        c42rb21f: {
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        c42rb11k: {
          pfx: 'c10r_key',
          type: 'Inp',
        },
      },
    }
  },

/*
  DROP TABLE t_c420;
  CREATE TABLE "t_c420" (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER,
    c420b21f INTEGER,
    c420b61k INTEGER,
    c420b51f INTEGER,
    c420cx1i INTEGER,
    c420cy1t TEXT,
    c420cy1f INTEGER,
    c420cz1i INTEGER
    , CONSTRAINT c420_unq1 UNIQUE (c420b21f, c420b61k, c420b51f, _vsn)
  );
  INSERT INTO t_c420 (_vsn, _ltt, c420b21f, c420b61k, c420b51f, c420cx1i, c420cy1t, c420cy1f, c420cz1i) 
  VALUES (1, 1, 1, 1, 1, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c420 (_vsn, _ltt, c420b21f, c420b61k, c420b51f, c420cx1i, c420cy1t, c420cy1f, c420cz1i) 
  VALUES (1, 1, 1, 1, 2, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c420 (_vsn, _ltt, c420b21f, c420b61k, c420b51f, c420cx1i, c420cy1t, c420cy1f, c420cz1i) 
  VALUES (1, 1, 1, 1, 3, 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_c420 SET _fst = _key;
*/

  c420: {
    0: {
      pfx: '担当別役割情報',
      b_vsn: true,
      d_insFlds: {
//        c420b21f: -1,
//        c420b61k: -1,
        c420b51f: -1,
      },
      dd_fldDefss: {
        c420b21f: {
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        c420b61k: {
          pfx: 'c42r_key',
          type: 'Inp',
        },
        c420b51f: { // c41r_fst
//          pfx: '役割',
          pfx: '割当る権限分類',
          type: 'Pck',
          n_col: 15,
        },
      },
    }
  },
};

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
